import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nodes: [],
  edges: []
};

const flowSlice = createSlice({
  name: "sld",
  initialState,
  reducers: {
    setNodesState: (state, action) => {
      state.nodes = action.payload;
    },
    setEdgesState: (state, action) => {
      state.edges = action.payload;
    }
  }
});

export const { setNodesState, setEdgesState } = flowSlice.actions;
export default flowSlice.reducer;
